import { render } from "./ListeOuvFerm.vue?vue&type=template&id=70e7145c&ts=true"
import script from "./ListeOuvFerm.vue?vue&type=script&lang=ts"
export * from "./ListeOuvFerm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__